import { observer } from 'mobx-react'

import { commonRepo } from '~/@common/services/repo.service'
import type { ProblemScoringColl } from '~/@pages/@common/(ProblemScoring)/@trait/ProblemScoring.trait'
import type { ProblemScoringViewOption } from '~/@pages/@common/(ProblemScoring)/@trait/ProblemScoringViewOption.trait'
import type { ProblemScoringFooterProps } from '~/@pages/@common/(ProblemScoring)/ProblemScoringCard/ProblemScoringFooter'
import ProblemScoringViewGuideOption from '~/@pages/@common/(ProblemScoring)/ProblemScoringViewGuideOption'
import 전체정답_전체삭제_제출 from '~/@pages/@common/(ProblemScoring)/전체정답_전체삭제_제출'
import { WorksheetDifficultyStatistics } from '~/@pages/@common/(QuickScoring)/ParentReportCards/WorksheetDifficultyStatistics'
import { WorksheetSupplementaryLearning } from '~/@pages/@common/(QuickScoring)/ParentReportCards/WorksheetSupplementaryLearning'
import { QuickScoringTemplate } from '~/@pages/@common/(QuickScoring)/QuickScoring.template'
import { alertClearAllAnswerModal } from '~/@pages/student-worksheet/$studentWorksheetId/scoring/@widgets/alertClearAllAnswerModal'

interface Props {
  score: number
  problemScoringColl: ProblemScoringColl<'WORKSHEET'>
  problemScoringViewOption: ProblemScoringViewOption<'NOT_학습모듈'>
  openConfirmToSubmitAnswersModal: () => void
  gradingCount: ProblemScoringColl<'WORKSHEET'>['gradingCount']
  clearAllAnswer: () => void
  onLocalUserInputChange?: ProblemScoringFooterProps['onLocalUserInputChange']
  onSubmitAnswerImmediately?: ProblemScoringFooterProps['onSubmitAnswerImmediately']
  isSubmittable?: boolean
  isDeletable?: boolean
}

export const WorksheetQuickScoring = observer(
  ({
    score,
    problemScoringColl,
    problemScoringViewOption,
    gradingCount,
    clearAllAnswer,
    openConfirmToSubmitAnswersModal,
    onLocalUserInputChange,
    onSubmitAnswerImmediately,
    isSubmittable = true,
    isDeletable = true,
  }: Props) => {
    const alertClearAllAnswer = () => {
      alertClearAllAnswerModal({
        onAllClear: clearAllAnswer,
      })
    }

    const isParentView = problemScoringViewOption.isParentView

    return (
      <>
        {problemScoringViewOption && (
          <ProblemScoringViewGuideOption viewOption={problemScoringViewOption} />
        )}
        <QuickScoringTemplate
          type="WORKSHEET"
          viewOption={problemScoringViewOption}
          problemScoringColl={problemScoringColl}
          score={score}
          // 학부모 모드일 때만 통계/보충학습 슬롯 주입 (학생은 카드 자체 미렌더)
          dashboardSlot={
            isParentView ? (
              <WorksheetDifficultyStatistics
                studentId={commonRepo.studentId}
                worksheetId={problemScoringViewOption.content.worksheetId}
              />
            ) : undefined
          }
          supplementaryLearningSlot={
            isParentView ? (
              <WorksheetSupplementaryLearning
                studentId={commonRepo.studentId}
                worksheetId={problemScoringViewOption.content.worksheetId}
              />
            ) : undefined
          }
          scoring={{
            ...gradingCount,
            total: problemScoringColl?.toArr.length || 0,
          }}
          onLocalUserInputChange={isParentView ? undefined : onLocalUserInputChange}
          onSubmitAnswerImmediately={isParentView ? undefined : onSubmitAnswerImmediately}
        />
        {!isParentView && !problemScoringViewOption.채점완료_혹은_채점불가능 && (
          <전체정답_전체삭제_제출
            className="flex-end"
            onAllClearClick={alertClearAllAnswer}
            onSubmitClick={() => {
              if (!problemScoringColl.toScoredArr.length) return
              openConfirmToSubmitAnswersModal()
            }}
            isSubmittable={isSubmittable}
            isDeletable={isDeletable}
            submitTitle={`${problemScoringColl.toScoredArr.length}문제 제출`}
          />
        )}
      </>
    )
  },
)
